import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { PublicLayout } from "@/components/site/PublicLayout";
import { ProtectedRoute } from "@/components/site/ProtectedRoute";
import Home from "@/pages/Home";
import Programmes from "@/pages/Programmes";
import ProgrammeDetail from "@/pages/ProgrammeDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

const AdminRoot = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/programmes" element={<Programmes />} />
            <Route path="/programmes/:id" element={<ProgrammeDetail />} />
            <Route path="/contact" element={<Contact />} />
          </Route>
          <Route path="/admin" element={<AdminRoot />}>
            <Route path="login" element={<AdminLogin />} />
            <Route index element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
